import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
import { FaFacebook } from "react-icons/fa";
import Button from "../shared/Button";
import signupPopup from "../../assets/login-signup/signup-popup.svg";
import indiaFlag from "../../assets/blog/indflag.svg";

export default function SignupModal({ toggleClose }) {
    const [formData, setFormData] = useState({
        name: "",
        phoneNumber: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle form submission logic here
        console.log("Form submitted:", formData);
        // Close modal after submission
        toggleClose(false);
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 backdrop-blur-sm">
            <div className="bg-white rounded-2xl overflow-hidden w-full max-w-[70%] h-[70%] relative flex">
                <div className="hidden md:block md:w-1/3 flex-1 bg-primary-color">
                    
                    {/* <img src={signupPopup} alt="signup-popup" className="w-full h-full object-contain" /> */}
                </div>
                <div className="w-full md:w-2/3 h-full">
                    {/* Close button */}
                    <button 
                        onClick={() => toggleClose(false)} 
                        className="absolute top-4 right-4 text-[#848383] hover:text-gray-700"
                    >
                        <FaTimes />
                    </button>
                    {/* Modal content */}
                    <div className="p-6 md:p-8 lg:px-12 flex flex-col justify-between">
                        <h2 className="text-center text-24 font-medium	 text-secondary-color mb-2">Welcome to <span className="text-primary-color">Mentorsity !</span></h2>
                        <h3 className="text-center text-3xl font-medium	 mb-8">Sign-up</h3>
                        
                        <form onSubmit={handleSubmit} className="border-b border-[#999999] mb-4">
                            <div className="mb-4 flex items-center justify-between">
                                
                                <label htmlFor="name" className="block text-lg font-medium text-primary-color mb-1 w-1/3">Name</label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    placeholder="eg. Arun"
                                    value={formData.name}
                                    onChange={handleChange}
                                    className="w-2/3 px-3 py-1.5 border border-gray-300 bg-[#F3F5FE] rounded-lg"
                                    required
                                />
                            </div>
                            
                            <div className="mb-4 flex items-center justify-between">
                                <label htmlFor="phoneNumber" className="block text-nowrap text-lg font-medium text-primary-color mb-1 w-1/3">Phone Number</label>
                                <div className="flex items-center w-2/3 justify-start">
                                    <div className="flex gap-1 items-center justify-center border border-gray-300 bg-[#F3F5FE] rounded-lg px-3 py-1.5 mr-2">
                                        <img src={indiaFlag} alt="india-flag" className="w-4 h-4" />
                                        <p className="text-sm">+91</p>
                                    </div>
                                    <input
                                        type="tel"
                                        id="phoneNumber"
                                        name="phoneNumber"
                                        placeholder="eg. 9999999999"
                                        value={formData.phoneNumber}
                                        onChange={handleChange}
                                        className="w-full px-3 py-1.5 border border-gray-300 bg-[#F3F5FE] rounded-md"
                                        required
                                    />
                                </div>
                            </div>
                            
                            <div className="flex justify-end my-8">
                                <button 
                                    type="submit" 
                                    className="bg-primary-color shadow-custom text-white px-8 py-1 rounded-lg"
                                >
                                    Next
                                </button>
                            </div>
                        </form>
                        
                        <div className="flex flex-col flex-1 justify-center items-center pt-4 gap-4 w-full">
                            <div className="flex items-center justify-center gap-4 w-[80%] mx-auto">
                                <FcGoogle size={36}/>
                                <button className="flex items-center justify-center gap-2 bg-[#EE2F06] text-white border border-gray-300 px-4 py-1 rounded-md w-full">
                                    Sign up with Google
                                </button>
                            </div>
                            <div className="flex items-center justify-center gap-4 w-[80%] mx-auto">
                                <FaFacebook size={36}/>
                                <button className="flex items-center justify-center gap-2 bg-primary-color text-white border border-gray-300 px-4 py-1 rounded-md w-full">
                                    Sign up with Facebook
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}